import React, { useState, useEffect } from "react";
import "./Banner.css";

import image1 from "../assets/imges/bg1.jpg";
import image2 from "../assets/imges/bg2.avif";
import image3 from "../assets/imges/bg1.jpg";

const Banner = () => {
  const slides = [
    { title: "સ્માર્ટ સાથી વેબસાઇટમાં તમારું સ્વાગત છે.", image: image1 },
    { title: "સ્માર્ટ સાથી વેબસાઇટમાં તમારું સ્વાગત છે.", image: image2 },
    { title: "સ્માર્ટ સાથી વેબસાઇટમાં તમારું સ્વાગત છે.", image: image3 },
  ];

  const [index, setIndex] = useState(0);

  // ✅ AUTO SLIDER
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="banner-container">
      <img src={slides[index].image} alt="" className="banner-image" />
      <div className="banner-text">{slides[index].title}</div>

      <button onClick={prevSlide} className="banner-arrow left">‹</button>
      <button onClick={nextSlide} className="banner-arrow right">›</button>

      <div className="banner-dots">
        {slides.map((_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            className={`banner-dot ${index === i ? "active" : ""}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Banner;
